/**
 * Core / Mint: Mint
 * ------------------------------------------------------------------------------
 * - Component for initiating the framework.
 *
 * @namespace Mint
 */
import MintCore from '~/core/mint/mint-core'
import MintComponents from '~/core/mint/mint-components'
import MintSections from '~/core/mint/mint-sections'

/**
 * Create a new Mint object.
 */
export default () => {

  /**
   * Initialise components.
   * - Handle Vue components for sections everywhere,
   * - Eventually this will have more functions
   * - i.e. `MintComponents().init()`
   */
  function init() {

    /**
     * MintSections handles mounting Vue-powered Sections
     * MintComponents handles standalone components.
     */
    MintComponents().init()
    MintSections().init()

    /**
     * Run Core *after* Sections and Components, so EventBus listeners
     * in the above instances can listen to events emitted.
     * - Used to sync Pinia.
     */
    MintCore().init()
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  })
}
